import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=5ddaf138&"
import script from "./Otp.vue?vue&type=script&lang=ts&"
export * from "./Otp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports